export var MuiFormGroup = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        marginBottom: theme.spacing(theme.spaces.main)
      };
    }
  }
};
//# sourceMappingURL=MuiFormGroup.js.map